import { isEqualStatoScommessaByKey, isTotalizzatore } from 'features/ippica/functions';
import {
  selectCodiceStatoAvvenimento,
  selectCurrentScommesseType,
  selectIsLoadingIppicaTipoScommessa,
} from 'features/ippica/selectors';
import { Stato } from 'features/ippica/types';
import { RootState, useTypedSelector } from 'lib/centralStore';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { IppicaEmpty } from '../../ippicaEmpty';
import { IppicaHeaderInfoAccordion } from '../../ippicaHeaderInfoAccordion/IppicaHeaderInfoAccordion';
import { DynamicIppicaMovimenti } from '../../ippicaMovimenti/IppicaMovimenti';
import { DynamicIppicaQuoteAccordionContainer } from '../../ippicaQuote/ippicaQuoteAccordionContainer/IppicaQuoteAccordionContainer';
import { IppicaQuoteFinali } from '../../ippicaQuote/ippicaQuoteFinali';
import { IppicaRisultatiRenderer } from '../../ippicaRisultatiRenderer';
import { DynamicIppicaScommesseRenderer } from '../../ippicaScommesseRenderer/IppicaScommesseRenderer';
import { DynamicIppicaTipiScommesseRenderer } from '../../ippicaTipiScommessaRenderer/IppicaTipiScommessaRenderer';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';

export const DynamicIppicaDetailsRendererCorse = dynamic(() =>
  import('features/ippica/components/ippicaDetailsRenderer/ippicaDetailsRendererCorse').then(
    (mod) => mod.IppicaDetailsRendererCorse
  )
);
export const IppicaDetailsRendererCorse = () => {
  const isOpen = useSelector(selectIsOpenCarrello);
  const codiceStatoAvvenimento = useTypedSelector(selectCodiceStatoAvvenimento);
  const currentScommesseType = useTypedSelector(selectCurrentScommesseType);

  return (
    <>
      <IppicaHeaderInfoAccordion hasMarginRight={!isOpen} />
      <div>
        {/* {isLoadingIppicaTipoScommessa ? <SkeletonIppicaAreaTipiScommessa /> : */}
        <DynamicIppicaTipiScommesseRenderer />
        {/* if race is payment or closed */}
        {(isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.InPagamento) ||
          isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Chiusa)) && <IppicaRisultatiRenderer />}
        {/* TODO AWAITING NEW API */}
        {isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.InPagamento) && (
          <IppicaQuoteFinali title="Quote Finali" hasMarginRight />
        )}
        {/* if race is cancelled */}
        {/* TODO ADD CANCELLED STATUS */}
        {isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Annullata) && (
          <IppicaEmpty hasMarginRight={!isOpen}>
            <span>La corsa è stata annullata </span>
          </IppicaEmpty>
        )}
        {/* if race is open */}
        {isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Aperta) && (
          <>
            <DynamicIppicaScommesseRenderer />
            {isTotalizzatore(currentScommesseType!) && (
              <>
                <DynamicIppicaMovimenti />
                <DynamicIppicaQuoteAccordionContainer />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
